/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/motherhood/components/standalone/Tag/theme';

export const TagTheme = theme;
